import GrantUserAccess from './GrantUserAccess';

export default GrantUserAccess;



// WEBPACK FOOTER //
// ./src/components/Pages/Account/GrantUserAccess/index.js